import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    common: {
      toast: {
        upload: {
          start: 'Téléversement en cours…',
          success: 'Téléversement réussi',
          error: 'Échec du téléversement',
        },
        type: {
          prompt: 'Veuillez confirmer le type du document.',
        },
        processing: {
          start: 'Traitement démarré…',
          progress: 'Analyse en cours…',
          success: 'Traitement terminé. Document prêt.',
          error: 'Échec du traitement du document',
          delay: 'Le traitement prend plus de temps que prévu.',
          updateError: 'Erreur lors de la mise à jour du document.',
        },
        changeSaved: 'Modification enregistrée.',
        updateSuccess: 'Mise à jour réussie.',
        updateError: 'Échec de la mise à jour.',
        documents: {
          loadError: 'Impossible de charger les documents',
          archiveError: "Impossible d'archiver le document",
          retryStart: 'Re-traitement lancé',
          retryError: 'Échec du re-traitement',
          downloadError: 'Échec du téléchargement du document',
        },
      },
      status: {
        ready: 'Prêt',
        processing: 'En cours',
        error: 'Erreur',
        archived: 'Archivé',
      },
      docType: {
        INVOICE: 'Facture',
        BANK_STATEMENT: 'Relevé bancaire',
        FINANCIAL_STATEMENT: 'États financiers',
        TAX_FORM: 'Document fiscal',
        TPS_TVQ: 'TPS/TVQ',
        T4_SLIPS: 'T4 Slips',
        R1_SLIPS: 'Relevé 1 Slips',
        LAW_TEXT_OR_PRESS_RELEASE: 'Textes de Loi / Communiqués',
        CONTRACT: 'Contrat',
        CHECK: 'Chèque',
        PURCHASE_ORDER: 'Bon de commande',
        PAYSLIP: 'Bulletin de paie',
        OTHER: 'Autre',
      },
      filters: {
        title: 'Filtres avancés',
        categories: 'Catégories',
        status: 'Statut',
        type: 'Type',
        date: 'Date',
        supplier: 'Fournisseur',
        validity: 'Validité',
        valid: 'Validé',
        invalid: 'Non Validé',
        all: 'Tous',
      },
      actions: {
        addDocument: 'Ajouter un document',
        confirm: 'Confirmer',
        cancel: 'Annuler',
        back: 'Retour',
        edit: 'Modifier',
        validate: 'Valider',
        download: 'Télécharger',
        archive: 'Archiver',
        clear: 'Effacer',
        analyze: 'Analyser',
        undo: 'Annuler',
      },
      empty: {
        selectDocument: 'Sélectionnez un document dans la liste à gauche',
        loading: 'Chargement…',
      },
      dialog: {
        confirmCategory: 'Confirmer la catégorie',
        aiDetected: "L'IA a identifié votre document. Confirmez ou modifiez la catégorie.",
        chooseDocType: 'Choisir le type de document',
        chooseMainCategory: 'Sélectionnez la catégorie principale de votre document.',
        confirmFilesTitle: 'Confirmer les fichiers',
        confirmFilesHint: 'Veuillez confirmer les fichiers à analyser.',
        filesToUpload: 'Fichiers à téléverser :',
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'fr',
  fallbackLng: 'fr',
  defaultNS: 'common',
  ns: ['common'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
